import { NamirasoftERPServer } from "namirasoft-erp";
import { NSMenuActionProps } from "namirasoft-site-react";

export class JournalEntryMenus
{
    static setFinalized(server: NamirasoftERPServer, getIDs: () => string[], getRows: () => { id: string; finalized: boolean }[], reload: () => void): NSMenuActionProps
    {
        return {
            id: "je-set-finalized",
            menu_item: "Set Finalized",
            isActive: () =>
            {
                let rows = getRows();
                if (rows.length === 0)
                    return false;
                return rows.every(r => !r.finalized);
            },
            onClick: {
                action: async (onFinished) =>
                {
                    try
                    {
                        for (let id of getIDs())
                            await server.journal_entry.SetFinalized(id, { finalized: true });
                        reload();
                    }
                    catch (err)
                    {
                    }
                    finally
                    {
                        onFinished();
                    }
                },
                showLoading: true
            }
        };
    }
    static unsetFinalized(server: NamirasoftERPServer, getIDs: () => string[], getRows: () => { id: string; finalized: boolean }[], reload: () => void): NSMenuActionProps
    {
        return {
            id: "je-unset-finalized",
            menu_item: "Unset Finalized",
            isActive: () =>
            {
                let rows = getRows();
                if (rows.length === 0)
                    return false;
                return rows.every(r => r.finalized);
            },
            onClick: {
                action: async (onFinished) =>
                {
                    try
                    {
                        for (let id of getIDs())
                            await server.journal_entry.SetFinalized(id, { finalized: false });
                        reload();
                    }
                    catch (err)
                    {
                    }
                    finally
                    {
                        onFinished();
                    }
                },
                showLoading: true
            }
        };
    }
}